<div [attr.id]="'aluno-card-' + aluno.id"
     class="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-2 transition-all duration-200 hover:shadow-lg hover:scale-[1.02] hover:border-blue-300 dark:hover:border-blue-600 active:scale-[0.98] cursor-pointer">
  <div class="flex items-center justify-between">
    <!-- Número e Nome -->
    <div class="flex items-center space-x-3 flex-1 min-w-0">
      <span [attr.id]="'aluno-numero-' + aluno.id" class="text-lg font-bold text-gray-500 dark:text-gray-400 w-8 flex-shrink-0">{{ aluno.numeroChamada || numero }}</span>
      <span [attr.id]="'aluno-nome-' + aluno.id" class="text-base text-gray-900 dark:text-gray-100 truncate min-w-0">{{ nomeAluno }}</span>
    </div>

    <!-- Ícone de Abonos/Justificativas e Botão P/F -->
    <div class="flex items-center space-x-3">
      <button
        [attr.id]="'aluno-abono-btn-' + aluno.id"
        (click)="abrirAbonosJustificativas.emit(aluno)"
        appPermissions
        [appPermissionsAny]="['AbonoFaltaPageMapping', 'JustificativaFaltaPageMapping']"
        class="relative w-10 h-10 flex items-center justify-center bg-blue-50 dark:bg-gray-700 hover:bg-blue-100 dark:hover:bg-blue-900 rounded-lg shadow-md transition-all duration-200 hover:scale-110 active:scale-95"
      >
        <lucide-icon
          name="files"
          class="w-5 h-5 transition-colors"
          [ngClass]="abonosJustificativasCount > 0 ? 'text-blue-600 dark:text-blue-400' : 'text-gray-600 dark:text-gray-400'"
        ></lucide-icon>

        <!-- Badge com contador -->
        <span
          *ngIf="abonosJustificativasCount > 0"
          class="absolute -top-1 -right-1 flex items-center justify-center min-w-[18px] h-[18px] bg-blue-600 dark:bg-blue-500 text-white text-[10px] font-bold rounded-full border-2 border-white dark:border-gray-700 px-1"
        >
          {{ abonosJustificativasCount }}
        </span>
      </button>

      <!-- Botão P/F — somente quando enturmado -->
      <button *ngIf="!aluno.desabilitado"
        [attr.id]="'aluno-presenca-btn-' + aluno.id"
        (click)="togglePresenca.emit(aluno)"
        [disabled]="!aulaRealizada || alterando"
        [class]="buttonClassDia"
        class="w-10 h-10 rounded font-bold text-white disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 hover:scale-110 hover:shadow-lg active:scale-95 relative"
      >
        <!-- Loading spinner -->
        <span *ngIf="alterando" class="absolute inset-0 flex items-center justify-center">
          <svg class="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
        </span>
        <!-- Label do status (oculto durante loading) -->
        <span [class.invisible]="alterando">
          {{ statusLabelDia }}
        </span>
      </button>
    </div>
  </div>

  <!-- Mensagem: aluno não enturmado nesta data -->
  <div *ngIf="aluno.desabilitado"
       [attr.id]="'aluno-nao-enturmado-' + aluno.id"
       class="flex items-center justify-center gap-2 mt-2 rounded-lg px-3 py-2 bg-[#F7E7BA] dark:bg-yellow-900/40 dark:border dark:border-yellow-700/60">
    <lucide-icon name="info" class="w-4 h-4 text-yellow-700 dark:text-yellow-400 flex-shrink-0"></lucide-icon>
    <span class="text-xs font-medium text-yellow-900 dark:text-yellow-200">
      O aluno não está enturmado nesta data
    </span>
  </div>
</div>
